import { Affix, Button, Card, Form } from "antd";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import IOUAdjustmentImportForm from "../IOUAdjustmentImportForm";
import { useEffect, useState } from "react";

const AddIOUAdjustmentImport = (props) => {
  const { width } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedIouData, setSelectedIouData] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const currentUser = useSelector((state) => state.auth?.user);

  useEffect(() => {
    if (location?.state?.selectedIouData) {
      setSelectedIouData(location.state.selectedIouData);
    }
  }, [location]);

  const discardForm = () => {
    navigate("/import-export-expense-tracking/iou-adjustment-for-import");
  };

  const addNewIOUCost = async () => {
    if (submitting) {
      return;
    }

    try {
      await form.validateFields();

      form.submit();
    } catch (error) {}
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="Add IOU Adjustment for Import"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discardForm()} disabled={submitting}>
                Discard
              </Button>,
              <Button
                size="small"
                key={2}
                type="primary"
                onClick={() => addNewIOUCost()}
                loading={submitting}
                disabled={submitting}
              >
                Submit
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <IOUAdjustmentImportForm
        form={form}
        currentUser={currentUser}
        createMode={true}
        selectedIouData={selectedIouData}
        onSubmittingChange={setSubmitting}
      />
    </>
  );
};

export default AddIOUAdjustmentImport;
